import accompany from '../../lib/img/icon/app_subject_important/accompany_important.svg';
import accompany_map from '../../lib/img/icon/app_subject_important/accompany_map_important.svg';
import attend_event from '../../lib/img/icon/app_subject_important/attend_event_important.svg';
import attend_event_map from '../../lib/img/icon/app_subject_important/attend_event_map_important.svg';
import buy_donate from '../../lib/img/icon/app_subject_important/buy_donate_important.svg';
import buy_donate_map from '../../lib/img/icon/app_subject_important/buy_donate_map_important.svg';
import care_in_hospital from '../../lib/img/icon/app_subject_important/care_in_hospital_important.svg';
import care_in_hospital_map from '../../lib/img/icon/app_subject_important/care_in_hospital_map_important.svg';
import cleaning from '../../lib/img/icon/app_subject_important/cleaning_important.svg';
import cleaning_map from '../../lib/img/icon/app_subject_important/cleaning_map_important.svg';
import congratulate from '../../lib/img/icon/app_subject_important/congratulate_important.svg';
import congratulate_map from '../../lib/img/icon/app_subject_important/congratulate_map_important.svg';
import cook_food from '../../lib/img/icon/app_subject_important/cook_food_important.svg';
import cook_food_map from '../../lib/img/icon/app_subject_important/cook_food_map_important.svg';
import feed_the_ward from '../../lib/img/icon/app_subject_important/feed_the_ward_important.svg';
import feed_the_ward_map from '../../lib/img/icon/app_subject_important/feed_the_ward_map_important.svg';
import grocery_set from '../../lib/img/icon/app_subject_important/grocery_set_important.svg';
import grocery_set_map from '../../lib/img/icon/app_subject_important/grocery_set_map_important.svg';
import haircut from '../../lib/img/icon/app_subject_important/haircut_important.svg';
import haircut_map from '../../lib/img/icon/app_subject_important/haircut_map_important.svg';
import happy_easter from '../../lib/img/icon/app_subject_important/happy_easter_important.svg';
import happy_easter_map from '../../lib/img/icon/app_subject_important/happy_easter_map_important.svg';
import help from '../../lib/img/icon/app_subject_important/help_important.svg';
import help_map from '../../lib/img/icon/app_subject_important/help_map_important.svg';
import help_studies from '../../lib/img/icon/app_subject_important/help_studies_important.svg';
import help_studies_map from '../../lib/img/icon/app_subject_important/help_studies_map_important.svg';
import holiday_help from '../../lib/img/icon/app_subject_important/holiday_help_important.svg';
import holiday_help_map from '../../lib/img/icon/app_subject_important/holiday_help_map_important.svg';
import redecorating from '../../lib/img/icon/app_subject_important/redecorating_important.svg';
import redecorating_map from '../../lib/img/icon/app_subject_important/redecorating_map_important.svg';
import transfer_a_person from '../../lib/img/icon/app_subject_important/transfer_a_person_important.svg';
import transfer_a_person_map from '../../lib/img/icon/app_subject_important/transfer_a_person_map_important.svg';
import walk_disabled_person from '../../lib/img/icon/app_subject_important/walk_disabled_person_important.svg';
import walk_disabled_person_map from '../../lib/img/icon/app_subject_important/walk_disabled_person_map_important.svg';
import walk_kids from '../../lib/img/icon/app_subject_important/walk_kids_important.svg';
import walk_kids_map from '../../lib/img/icon/app_subject_important/walk_kids_map_important.svg';
import wash_hygiene from '../../lib/img/icon/app_subject_important/wash_hygiene_important.svg';
import wash_hygiene_map from '../../lib/img/icon/app_subject_important/wash_hygiene_map_important.svg';
import worship from '../../lib/img/icon/app_subject_important/worship_important.svg';
import worship_map from '../../lib/img/icon/app_subject_important/worship_map_important.svg';
import happy_christmas from '../../lib/img/icon/app_subject_important/happy_christmas_important.svg';
import happy_christmas_map from '../../lib/img/icon/app_subject_important/happy_christmas_map_important.svg';
import present_christmas from '../../lib/img/icon/app_subject_important/present_christmas_important.svg';
import present_christmas_map from '../../lib/img/icon/app_subject_important/present_christmas_map_important.svg';

// Person
import person_active from '../../lib/img/icon/person/person_active.svg';
import person from '../../lib/img/icon/person/person.svg';
import person_cluster from '../../lib/img/icon/person/person_cluster.svg';

export const collectionImportantSvg = {
  person: {
    person_active,
    person,
    person_cluster,
  },
  app_subject: {
    accompany,
    accompany_map,
    attend_event,
    attend_event_map,
    buy_donate,
    buy_donate_map,
    care_in_hospital,
    care_in_hospital_map,
    cleaning,
    cleaning_map,
    congratulate,
    congratulate_map,
    cook_food,
    cook_food_map,
    feed_the_ward,
    feed_the_ward_map,
    grocery_set,
    grocery_set_map,
    haircut,
    haircut_map,
    happy_easter,
    happy_easter_map,
    help,
    help_map,
    help_studies,
    help_studies_map,
    holiday_help,
    holiday_help_map,
    redecorating,
    redecorating_map,
    transfer_a_person,
    transfer_a_person_map,
    walk_disabled_person,
    walk_disabled_person_map,
    walk_kids,
    walk_kids_map,
    wash_hygiene,
    wash_hygiene_map,
    worship,
    worship_map,
    happy_christmas,
    happy_christmas_map,
    present_christmas,
    present_christmas_map,
  },
};

export type DicIconKeys = keyof typeof collectionImportantSvg;

export type DicIconName =
  | keyof (typeof collectionImportantSvg)['person']
  | keyof (typeof collectionImportantSvg)['app_subject'];
